/**
 * Runtime config, fetched from the Worker rather than baked in at build time.
 *
 * There are no VITE_SUPABASE_* variables in this project. The environment a
 * bundle talks to is decided by the Worker serving it, so the same build can
 * be promoted from staging to production without a rebuild and there is no way
 * to ship a bundle pointed at the wrong database.
 */

export interface PublicConfig {
  environment: "development" | "staging" | "production";
  supabaseUrl: string;
  supabasePublishableKey: string;
  /** null when Turnstile is off for this environment. */
  turnstileSiteKey: string | null;
}

let pending: Promise<PublicConfig> | null = null;

export function loadConfig(): Promise<PublicConfig> {
  if (!pending) {
    pending = fetch("/api/config", { headers: { accept: "application/json" } })
      .then(async (response) => {
        if (!response.ok) {
          throw new Error(`Could not load app configuration (${response.status})`);
        }
        return (await response.json()) as PublicConfig;
      })
      .catch((error: unknown) => {
        // Let a later attempt retry instead of caching the failure forever.
        pending = null;
        throw error;
      });
  }
  return pending;
}
